import { useContext, useEffect, useState } from 'react'
import images from '../../../assets/img/images'
import catchError from '../../../components/global/CatchError'
import Loader from '../../../components/global/Loader'
import Title from '../../../components/global/Title'
import { sweetAlertSuccess } from '../../../components/sweetalert/Alert'
import Table from '../../../components/table/Table'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import { useVerifyAdminToken } from '../../../hooks/useVerifyAdminToken'
import apiClient from '../../../services/apiClient'
import { serverFile } from '../../../services/file.service'
import { NewsModel, NewsType, helperNewsType } from '../../../types/news.type'
import { parseHtmlContent } from '../../../utils/htmlRenderer'
import { AdminContainer, LinkBtn, TitleWrapper } from '../users/AdminUsers'

const getServerFile = (newsItem: NewsModel) => (newsItem.image ? serverFile(newsItem.image) : '')
const filterValue = (news: NewsModel[], res: any) => news.filter((newsData) => newsData.id !== res.data.id)

const AdminNews = () => {
    const user = useContext(UserContext)
    const [news, setNews] = useState<NewsModel[] | undefined>(undefined)

    const verifyToken = useVerifyAdminToken()
    const lng = useLangSelected()

    const [currentLang, setCurrentLang] = useState(lng)

    const tableHeader = ['#', 'Titre', 'Description', 'Type', 'Image', 'Lien', '', '']

    useEffect(() => {
        verifyToken()
        if (!news || currentLang !== lng) {
            setCurrentLang(lng)
            apiClient
                .post('/news/all', { lng })
                .then(({ data }) => {
                    setNews(
                        data.map((newsItem: NewsModel) => ({
                            id: newsItem.id,
                            title: newsItem.title,
                            description: parseHtmlContent(newsItem.description),
                            type: helperNewsType(newsItem.type),
                            image: newsItem.type === NewsType.MEETING ? images.reunion : getServerFile(newsItem),
                            link: newsItem.link,
                            edit: `/${lng}/bva-admin/articles/${newsItem.id}`,
                            remove: true,
                        })),
                    )
                })
                .catch((err) =>
                    catchError(err.response?.data || { status: 500, message: 'Une erreur est survenue' }, () => {
                        localStorage.removeItem('tokenAdmin')
                        user.adminData = undefined
                        window.location.reload()
                    }),
                )
        }
    }, [news, user, lng])

    if (!news) return <Loader />

    const deleteById = (id: number) => {
        verifyToken()
        apiClient
            .delete(`/news/${id}`)
            .then((res) => {
                sweetAlertSuccess('La suppression de cette article est réussi').then(() => {
                    setNews([...filterValue(news, res)])
                })
            })
            .catch((err) =>
                catchError(err.response?.data || { status: 500, message: 'Une erreur est survenue' }, () => {
                    localStorage.removeItem('tokenAdmin')
                    user.adminData = undefined
                    window.location.reload()
                }),
            )
    }

    return (
        <>
            <TitleWrapper data-testid="admin-news-title-wrapper">
                <Title dataTestId="admin-news-title">Articles</Title>
                <LinkBtn
                    data-testid="admin-news-create-btn"
                    to={`/${lng}/bva-admin/articles/creer`}
                    className="btn btn-primary mb-2"
                >
                    Créer
                </LinkBtn>
            </TitleWrapper>
            <AdminContainer data-testid="admin-news-container">
                <Table
                    data-testid="admin-news-table"
                    tableData={news}
                    tableHeader={tableHeader}
                    deleteById={deleteById}
                />
            </AdminContainer>
        </>
    )
}

export default AdminNews
